import { Icon } from '@aibees/shared/components';
import { SHARED_ROUTES as R } from '@aibees/shared/constants';
import { classnames } from '@aibees/shared/utils';
import { Box, Button, Card, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExpiredLinkPasswordPageProps as Props } from './types';

export const ExpiredLinkPasswordPage = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('ExpiredLinkPasswordPage', className)}
      sx={SX.root}
      title={<Typography variant="h6">Invite Link Expired</Typography>}
      titleProps={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      contentSx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography
        variant="body4"
        color="grey.500"
        fontWeight={500}
        textAlign="center"
      >
        The invitation link you’re trying to access has expired or is no longer
        valid.
      </Typography>
      <Card variant="outlined" sx={SX.card}>
        <Icon name="clock" size={26} color="grey.700" />
      </Card>
      <Typography
        variant="body5"
        fontWeight={400}
        color="grey.500"
        textAlign="center"
      >
        This could be due to the invitation expiring after a certain period or
        the sender cancelling the invitation.
      </Typography>
      <Box textAlign="center">
        <Button variant="outlined" size="small" href={R.home} sx={{ mt: 2 }}>
          Return to Home
        </Button>
      </Box>
    </Styled.Wrapper>
  );
});

ExpiredLinkPasswordPage.displayName = 'ExpiredLinkPasswordPage';
